var renderTag = require('../../utils/render-tag');

module.exports = function (field, block) {

  field.fields.forEach((item) => {
    var itemBlock = renderTag.div('', `${item.id}-block`);
    renderTag.label(item.name, item.label).appendTo(itemBlock);
    renderTag.select(item.name, '', item.items).appendTo(itemBlock);
    itemBlock.appendTo(block);
  });

  return block;

};